import { initClipboardHelper } from "../../../utils/hs-copy-clipboard-helper";
import { userDetailStore, UserDetailType} from "../../../stores/userDetailStore";

export function ReferUrl() {
  let userDetailStoreUnsubscribe: () => void;
  let $urlInput: null | HTMLInputElement = null;
  function init() {
    initClipboardHelper();
    $urlInput = document.getElementById("refer_url") as HTMLInputElement | null;
    userDetailStoreUnsubscribe = userDetailStore.subscribe(({ userDetail }) => populate({  userDetail })); // populate the loading state if workspaces loading
    populate({ userDetail: userDetailStore.userDetail });
  }

  async function populate({ userDetail }: { userDetail: UserDetailType }) {
    $urlInput!.value = `${import.meta.env.VITE_APP_URL}signup?r=${userDetail.unique_user_id}`;
  }

  function cleanUp() {
    if (userDetailStoreUnsubscribe) {
        userDetailStoreUnsubscribe();
    }
  }
  function render() {
    return /*html*/`<div class="p-4 md:p-5 bg-white border border-gray-200 shadow-sm rounded-xl dark:bg-neutral-800 dark:border-neutral-700">
  <!-- Title -->
  <div class="mb-4 xl:mb-4">
    <h1 class="text-lg font-semibold text-gray-800 dark:text-neutral-200">
      Refer & Earn
    </h1>
    <p class="text-sm text-gray-500 dark:text-neutral-500">
      Share the referral link below with friends and get $10 credit for each paid signup after 30 days
    </p>
  </div>
  <!-- End Title -->

  <div class="space-y-5">
    <!-- Filter Group -->
    <div class="flex sm:grid sm:grid-cols-1 gap-x-2 sm:gap-x-5">
      <div>
        <!-- Input Form -->
        <div class="flex items-center gap-x-2">
          <input 
            id="refer_url" 
            type="text"
            class="py-2 px-3 block w-full border-gray-200 rounded-lg text-sm placeholder:text-gray-400 focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder:text-neutral-500 dark:focus:ring-neutral-600"
            readonly="" 
            value=""
          >

          <button 
            type="button"
            class="js-clipboard [--is-toggle-tooltip:false] hs-tooltip size-[38px] shrink-0 inline-flex justify-center items-center gap-x-2 rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-200 dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-200 dark:focus:bg-neutral-600"
            data-clipboard-target="#refer_url" 
            data-clipboard-action="copy"
            data-clipboard-success-text="Copied"
          >
            <svg 
              class="js-clipboard-default shrink-0 size-4" 
              xmlns="http://www.w3.org/2000/svg" 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
            >
              <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
              <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
            </svg>
            <svg 
              class="js-clipboard-success hidden size-4" 
              xmlns="http://www.w3.org/2000/svg" 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span
              class="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity hidden invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded-lg shadow-sm dark:bg-neutral-700"
              role="tooltip"
              style="position: fixed; inset: auto auto 0px 0px; margin: 0px; transform: translate(1213px, -144px);"
              data-popper-placement="top"
            >
              <span class="js-clipboard-success-text">Copy</span>
            </span>
          </button>
        </div>
        <!-- End Input Form -->
      </div>
    </div>
    <!-- End Filter Group -->
  </div>
</div>
`;
  }
  

  return { init, render, cleanUp };
}
